import { Pipe, PipeTransform } from '@angular/core';
import { SIZE_THUMB, SIZE_MEDIUM } from '../consts/appConsts';

@Pipe({
    name: 'thumb',
})
export class ThumbPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (!value || typeof value !== 'string') {
            return value;
        }
        return value.replace(SIZE_MEDIUM, SIZE_THUMB);
    }
}
